import { atom } from 'recoil';
import { IAcao } from '../../commons/types/crm';


export const acaosAtom = atom<IAcao[]>({
  key: 'acaos', 
  default: [] as IAcao[],
}); 
